<template>
  <div class="admin-card h-100">
    <div class="card-body p-3">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h6 class="mb-0 font-weight-bold" style="color:#0f172a;">
          <i class="bi bi-exclamation-triangle-fill text-danger mr-1"></i>
          Churn Risks
        </h6>
        <span class="pill pill-danger">{{ risks.length }}</span>
      </div>

      <div v-if="risks.length === 0" class="text-center text-secondary py-3">
        <i class="bi bi-check-circle-fill text-primary" style="font-size:1.5rem;"></i>
        <p class="mt-2 mb-0"><small>No at-risk companies</small></p>
      </div>

      <div v-else style="max-height:320px;overflow-y:auto;">
        <div
          v-for="company in risks"
          :key="company.id"
          class="d-flex align-items-center justify-content-between py-2 border-bottom"
        >
          <div class="flex-grow-1 mr-2" style="min-width:0;">
            <p class="mb-0 font-weight-bold text-truncate" style="font-size:.85rem;">
              {{ company.name }}
            </p>
            <small class="text-secondary">
              <span v-if="company.due_date" :class="isDueDatePast(company.due_date) ? 'text-danger' : ''">
                Due: {{ formatDate(company.due_date) }}
              </span>
              <span v-if="company.last_activity" class="ml-2">
                Active: {{ fromNow(company.last_activity) }}
              </span>
            </small>
          </div>
          <div class="flex-shrink-0">
            <span :class="['pill', statusBadge(company)]">{{ statusLabel(company) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminChurnPanel',
  props: {
    risks: { type: Array, default: () => [] },
  },
  methods: {
    isDueDatePast(date) {
      return moment(date).isBefore(moment());
    },
    formatDate(date) {
      return moment(date).format('D MMM YY');
    },
    fromNow(date) {
      return moment(date).fromNow();
    },
    statusLabel(company) {
      if (!company.due_date) return 'No billing';
      if (this.isDueDatePast(company.due_date)) return 'Overdue';
      return 'At risk';
    },
    statusBadge(company) {
      if (!company.due_date) return 'pill-secondary';
      if (this.isDueDatePast(company.due_date)) return 'pill-danger';
      return 'pill-dark';
    },
  },
};
</script>

<style scoped>
.admin-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 14px;
}
.pill {
  display: inline-block;
  font-size: .7rem;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 20px;
}
.pill-danger { background: rgba(220,53,69,.1); color: #dc3545; }
.pill-dark { background: #f1f5f9; color: #0f172a; }
.pill-secondary { background: #f1f5f9; color: #64748b; }
</style>
